import React from "react";
import { AiOutlineInfoCircle } from "react-icons/ai";
import SimpleReactLightbox, { SRLWrapper } from "simple-react-lightbox";
import NavigationBtns from "./Navigation-btns";

const Introduction = () => {
  return (
    <div
      className="introduction "
      data-aos="fade-right"
      data-aos-delay="300"
      data-aos-duration="1000"
    >
      <div className="alert alert-primary mb-5" role="alert">
        <div className="mb-2">
          <AiOutlineInfoCircle size={22} /> <strong>INFO</strong>
        </div>
        Keep /configs/credential.php and /configs/init.php file while updating.
        If you don’t keep them, you may have a problem with lisence.
      </div>

      <h1 className="title">Introduction</h1>

      <h3 className="introduction-title">Overview</h3>
      <strong className="introduction-subTitle">
        Welcome to - <strong className="strong">Qrcode SAAS.</strong>
      </strong>

      <div>
        Benefits of SaaS QR Menu / POS for restaurants <br />
        No need for printed menus. <br />
        No need for POS, waiter and kitchen apps. <br />
        Manage all your in-store orders. <br />
        QR and digital menus that showcase food images and videos. <br />
        Increased efficiency through contactless orders, re-orders and payments.{" "}
        <br />
        Simple intuitive interface and expansive features comparable to
        market-leading apps at a fraction of a cost. <br />
        For QR-menus, no need to download apps. Scan a QR Code to access a menu
        link on a browser to order and pay. <br />
        <br />
        <div className="introduction-img-container">
          <SimpleReactLightbox>
            <SRLWrapper>
              <a
                href="/assets/img/project/qrcode-admin.png"
                data-fancybox
                rel="nofollow"
              >
                <img
                  src="/assets/img/project/qrcode-admin.png"
                  alt="admin"
                  loading="lazy"
                  className="img-responsive-full"
                />
              </a>
            </SRLWrapper>
          </SimpleReactLightbox>
        </div>
        <div className="line-break" />
        <h3 className="introduction-contentTitle">
          2 Apps developed using Flutter
        </h3>
        • Waiter application <br />
        • POS application <br />
        <h3 className="introduction-contentTitle">
          3 web panel developed using Laravel & React Js
        </h3>
        • Admin web panel
        <br />
        • Manager web panel <br />
        • Waiter web panel <br />
        <h3 className="introduction-contentTitle">
          1 website developed using Javascript & Vite
        </h3>
        • Customer web site (QR Menu) <br />
        <h3 className="introduction-contentTitle">
          1 website developed using Typescript & Next Js
        </h3>
        • Landing Page <br />
        <div className="line-break" />
      </div>

      <NavigationBtns />
    </div>
  );
};

export default Introduction;
